document.addEventListener('DOMContentLoaded', function () {

  const hero = document.querySelector('.golf-hero');
  if (!hero) return;

  const slides = hero.querySelectorAll('.golf-slide');
  const prevBtn = hero.querySelector('.prev');
  const nextBtn = hero.querySelector('.next');
  const dotsContainer = hero.querySelector('.hero-dots');

  if (!slides.length) return;

  let currentIndex = 0;
  let autoplay;
  let isAnimating = false;

  /* SETTINGS */
  const AUTOPLAY_DELAY = 7000; // slide stays 7 sec
  const TRANSITION_DURATION = 1200; // smooth transition

  /* Create dots */
  slides.forEach((slide, index) => {

    const dot =
      document.createElement('button');

    dot.classList.add('hero-dot');

    if (index === 0) {
      dot.classList.add('active');
    }

    dot.addEventListener('click', () => {
      if (index !== currentIndex) {
        goToSlide(index);
      }
    });

    dotsContainer.appendChild(dot);
  });

  const dots =
    hero.querySelectorAll('.hero-dot');

  /* Main update slider */
  function updateSlider(newIndex) {

    if (isAnimating) return;

    isAnimating = true;

    const currentSlide =
      slides[currentIndex];

    const nextSlide =
      slides[newIndex];

    /* reset animation classes */
    slides.forEach(slide => {
      slide.classList.remove(
        'slide-enter',
        'slide-exit',
        'active'
      );
    });

    /* old slide exit */
    currentSlide.classList.add(
      'slide-exit'
    );

    /* new slide enter */
    nextSlide.classList.add(
      'active',
      'slide-enter'
    );

    /* dots */
    dots.forEach(dot =>
      dot.classList.remove('active')
    );

    dots[newIndex].classList.add(
      'active'
    );

    currentIndex = newIndex;

    setTimeout(() => {
      isAnimating = false;
    }, TRANSITION_DURATION);
  }

  function nextSlide() {

    const nextIndex =
      currentIndex >=
      slides.length - 1
        ? 0
        : currentIndex + 1;

    updateSlider(nextIndex);
  }

  function prevSlide() {

    const prevIndex =
      currentIndex <= 0
        ? slides.length - 1
        : currentIndex - 1;

    updateSlider(prevIndex);
  }

  function goToSlide(index) {
    updateSlider(index);
    resetAutoplay();
  }

  /* Buttons */
  nextBtn?.addEventListener(
    'click',
    () => {
      nextSlide();
      resetAutoplay();
    }
  );

  prevBtn?.addEventListener(
    'click',
    () => {
      prevSlide();
      resetAutoplay();
    }
  );

  /* Swipe */
  let touchStartX = 0;

  hero.addEventListener(
    'touchstart',
    e => {
      touchStartX =
        e.changedTouches[0].screenX;
    },
    { passive: true }
  );

  hero.addEventListener(
    'touchend',
    e => {

      const touchEndX =
        e.changedTouches[0].screenX;

      const diff =
        touchStartX - touchEndX;

      if (diff > 60) {
        nextSlide();
      }

      if (diff < -60) {
        prevSlide();
      }

    },
    { passive: true }
  );

  /* Autoplay */
  function startAutoplay() {
    autoplay = setInterval(
      nextSlide,
      AUTOPLAY_DELAY
    );
  }

  function stopAutoplay() {
    clearInterval(autoplay);
  }

  function resetAutoplay() {
    stopAutoplay();
    startAutoplay();
  }

  hero.addEventListener(
    'mouseenter',
    stopAutoplay
  );

  hero.addEventListener(
    'mouseleave',
    startAutoplay
  );

  /* Init */
  slides[0].classList.add(
    'active',
    'slide-enter'
  );

  startAutoplay();

});